import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axios, axiosCandidateInstance } from "./axios";

export const useGetCandidateDocuments = () => {
  const [state, execute, cancel] = axios<Omit<IDocument, "author" | "metadata">[], void, unknown>({
    method: "GET",
    withCredentials: true,
  });

  const callback = useCallback(
    (candidateId: ObjectId) => {
      return execute({
        url: `/${candidateId}/documents`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetCandidateDocumentsSuspense = (candidateId: ObjectId) => {
  return useSuspense(
    () => axiosCandidateInstance.get<Omit<IDocument, "author" | "metadata">[]>(`/${candidateId}/documents`),
    [candidateId]
  );
};
